import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';

export const exposeNoopTargetingExperiments = () => {
	if (fg('jira_1_day_core_actions_no_ati_gate')) {
		// Firing exposure for an AA test, noop for both control and variation
		expVal('jira_1_day_core_actions_no_ati', 'cohort', 'control');
	}
	if (fg('jira_2_day_core_actions_no_ati_gate')) {
		// Firing exposure for an AA test, noop for both control and variation
		expVal('jira_2_day_core_actions_no_ati', 'cohort', 'control');
	}
};
